// ============================================
// VISTASGUARDADAS.JS — combinaciones de filtros con nombre (EXPEDIENTES-RESUMEN FRENTE D, 2026-09-17)
// ============================================
// "Mis atorados", "Sin cotizar +10 dias"... En vez de volver a armar la misma combinacion de
// filtros cada mañana, se guarda una vez con nombre y queda a un clic en la fila principal.
//
// POR QUE EN localStorage Y POR USUARIO
// Es una preferencia de pantalla, no un dato del negocio: no merece una tabla ni un endpoint, y si
// se pierde no pasa nada. Se guarda POR USUARIO porque en Beep se comparten equipos: las vistas de
// uno no tienen por que aparecerle al siguiente que entre. La clave va dentro de UN solo objeto
// ({ "<usuarioId>": [...] }) para no sembrar el localStorage de claves sueltas, igual que hace
// EXPEDIENTE_DRAFT.

import { storage, STORAGE_KEYS } from './storage';

// Cuantas se enseñan como boton en la fila principal. El resto vive dentro del panel de Filtros:
// mas de tres botones y la fila deja de caber en un portatil, que es justo lo que se esta
// arreglando en este sprint.
export const MAX_VISTAS_VISIBLES = 3;
// Tope total, para que nadie llene el localStorage sin querer.
export const MAX_VISTAS = 12;

function leerTodo() {
  const o = storage.get(STORAGE_KEYS.EXPEDIENTES_VISTAS);
  return (o && typeof o === 'object' && !Array.isArray(o)) ? o : {};
}

export function leerVistas(usuarioId) {
  if (usuarioId == null) return [];
  const lista = leerTodo()[String(usuarioId)];
  return Array.isArray(lista) ? lista.filter(v => v && v.id && v.nombre) : [];
}

function escribirVistas(usuarioId, lista) {
  if (usuarioId == null) return lista;
  const todo = leerTodo();
  todo[String(usuarioId)] = lista.slice(0, MAX_VISTAS);
  storage.set(STORAGE_KEYS.EXPEDIENTES_VISTAS, todo);
  return todo[String(usuarioId)];
}

export function guardarVista(usuarioId, nombre, filtros) {
  const limpio = String(nombre || '').trim().slice(0, 28);
  if (!limpio) return leerVistas(usuarioId);
  const lista = leerVistas(usuarioId);
  // Mismo nombre = se reemplaza (guardar otra vez "Mis atorados" actualiza la que ya existia,
  // que es lo que espera cualquiera; no crea una segunda igual).
  const sinRepetir = lista.filter(v => v.nombre.toLowerCase() !== limpio.toLowerCase());
  const nueva = { id: `v${Date.now()}`, nombre: limpio, filtros: { ...filtros } };
  return escribirVistas(usuarioId, [nueva, ...sinRepetir]);
}

export function borrarVista(usuarioId, id) {
  return escribirVistas(usuarioId, leerVistas(usuarioId).filter(v => v.id !== id));
}

// ¿Los filtros de esta vista son EXACTAMENTE los que hay puestos ahora? Sirve para marcar el boton
// como activo. Se comparan solo las claves que la vista guardo, normalizando '' y null al mismo
// "sin filtro" (los estados del componente usan uno u otro segun el filtro, por historia).
const vacio = (v) => v == null || v === '' || v === false;
export function vistaActiva(vista, filtrosActuales) {
  if (!vista || !vista.filtros) return false;
  const claves = new Set([...Object.keys(vista.filtros), ...Object.keys(filtrosActuales || {})]);
  for (const k of claves) {
    const a = vista.filtros[k];
    const b = (filtrosActuales || {})[k];
    if (vacio(a) && vacio(b)) continue;
    if (String(a) !== String(b)) return false;
  }
  return true;
}
